import styles from './dashboardRoot.module.css';

/** Scopes the dashboard design tokens to the dashboard subtree inside the legacy content region. */
export default function DashboardRoot({ children }) {
    return (
        <div className={styles.root} data-dashboard-root>
            {children}
        </div>
    );
}
